import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { PropsWithChildren, ReactElement } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { ErrorFallbackComponent } from '../errors/error-fallback.component';

interface AppErrorBoundaryComponentProps extends PropsWithChildren {
  FallbackComponent?: ({
    resetErrorBoundary,
    error,
  }: FallbackProps) => ReactElement;
}
export const AppErrorBoundaryComponent = ({
  children,
  FallbackComponent = ErrorFallbackComponent,
}: AppErrorBoundaryComponentProps) => {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary FallbackComponent={FallbackComponent} onReset={reset}>
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};
